export default __webpack_public_path__ + "static/media/map.e35411af.webp";